import './App.css';
import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { redTheme } from 'oui';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from 'oui';

import { Toast } from 'oui';
import useToast from './application/hooks/useToast';
import Router from './Router';

import AnalyticsTracker from './application/helper/AnalyticsTracker';

function App() {
  const [theme, setTheme] = useState(redTheme);
  const location = useLocation();
  const { toast } = useToast();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
      });
    }, 0);

    // const matchKt = matchPath('/kt/*', location.pathname);
    // setTheme(matchKt ? blackTheme : redTheme);

    // if (['/extlink', '/'].includes(location.pathname)) return;

    // TagManager.dataLayer({
    //   dataLayer: {
    //     event: 'content-view',
    //     'content-name': `${location.pathname}${location.search}${location.hash}`, // path
    //     'content-view-name': `${location.pathname}${location.search}${location.hash}`, // screenName
    //     // utm_campaign: searchParams.get('utm_campaign'),
    //     // utm_medium: searchParams.get('utm_medium'),
    //     // utm_source: searchParams.get('utm_source'),
    //     // utm_content: searchParams.get('utm_content'),
    //   },
    // });
  }, [location]);

  return (
    <>
      {/* GA 트래킹 */}
      <AnalyticsTracker />

      {/* @ts-ignore */}
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <Router />
        <Toast
          isOpenToast={toast.open}
          onClickCloseToast={toast.onClose}
          message={toast.message}
        />
      </ThemeProvider>
    </>
  );
}

export default App;
